export default function detectMainNavigationState() {
    const handheldMenuRoot = document.querySelector('.main-nav-mobile .wp-block-navigation__responsive-container');
    if(handheldMenuRoot) {
        // Observe changes to the mobile menu state and toggle class on root node
        const handheldObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes") {
                    document.documentElement.classList.toggle('handheld-menu-opened', mutation.target.classList.contains('is-menu-open'));
                }
            });
        });
        handheldObserver.observe(handheldMenuRoot, {
            attributes: true
        });
    }
    
    const megaMenuElements = document.querySelectorAll('.main-nav .wp-block-outermost-mega-menu__toggle');
    if(megaMenuElements.length) {
        // Observe changes to the desktop menu state and toggle class on root node
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === "attributes") {
                    document.documentElement.classList.toggle('desktop-menu-opened', mutation.target.getAttribute('aria-expanded') === 'true');
                }
            });
        });
        megaMenuElements.forEach((megaMenuRoot) => {
            observer.observe(megaMenuRoot, {
                attributes: true
            });
        });
    }
};